export default __webpack_public_path__ + "static/media/gallery3.d1b5891a.jpg";